import { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { JobPostingLineChart } from './charts/JobPostingLineChart';
import { JobSubmissionLineChart } from './charts/JobSubmissionLineChart';
import RecentApps from './components/RecentApps';
import Header from './components/Header';
import Aside from './components/Aside';
import ProdzFooter from './components/Footer';
import RSSFeed from './components/RSSFeed';
import Nav from './components/Nav';

const connector = connect((state, ownProps) => ({ 
 ...state.user,
 employer: state.user.currentEmployer
}), {});
function Dashboard({ user, employer }) {
  return (
    <>
    <Helmet>
      <title>Dashboard | Productions.com</title>
    </Helmet>
      <div className="min-h-full">
        <Nav />
        <>
          <Header publicId={employer.logo} />
          <Aside />

          <main className="p-4 sm:ml-64">
              { employer.value === 0 ? 
                <div className="w-full mb-2 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700">
                  <div className="text-2xl">Welcome { user.first_name }</div>
                </div> : <></> 
              }
            <div className="mx-auto py-3 sm:px-6 lg:px-8">
              {/* Replace with your content */}
              <div className="grid grid cols-1 md:grid-cols-2 gap-3">
                <div className="w-full max-w-full px-3 mt-0 shadow-lg">

                { employer.value !== 0 ?  <div className="relative z-20 flex flex-col min-w-0 break-words bg-white border-0 border-solid dark:bg-gray-950 border-black-125 shadow-soft-xl dark:shadow-soft-dark-xl rounded-2xl bg-clip-border">
                    <div className="p-6 pb-0 mb-0 border-b-0 border-solid border-black-125 rounded-t-2xl">
                      <h6 className="text-black text-2xl">Daily Job Postings</h6>
                    </div>
                    <div className="flex-auto p-4" style={{ height: '250px' }}>
                      <JobPostingLineChart employer={employer.value} />
                    </div>
                  </div> : <></>
                }

                </div>
                <div className="w-full max-w-full px-3 mt-0 shadow-lg">
                  
                 { employer.value !== 0 ? <div className="relative z-20 flex flex-col min-w-0 break-words bg-white border-0 border-solid dark:bg-gray-950 border-black-125 shadow-soft-xl dark:shadow-soft-dark-xl rounded-2xl bg-clip-border">
                    <div className="p-6 pb-0 mb-0 border-b-0 border-solid border-black-125 rounded-t-2xl">
                      <h6 className="text-black text-2xl">Daily Job Applications</h6>
                    </div>
                    <div className="flex-auto p-4" style={{ height: '250px' }}>
                      <JobSubmissionLineChart employer={employer.value} />
                    </div>
                  </div> : <></>
                  }                  
                </div>
              </div>
              { employer.value !== 0 ? 
              <div className="grid grid cols-1 md:grid-cols-1">
                <div className="relative z-20 flex flex-col min-w-0 break-words bg-white border-0 border-solid dark:bg-gray-950 border-black-125 shadow-soft-xl dark:shadow-soft-dark-xl rounded-2xl bg-clip-border">
                    <div className="p-6 pb-0 mb-0 border-b-0 border-solid border-black-125 rounded-t-2xl">
                      <RecentApps employer={employer.value} />
                    </div>
                  </div>
              </div>
              : null }
              <div className="grid grid cols-1 md:grid-cols-1">
                <div className="relative z-20 flex flex-col min-w-0 break-words bg-white border-0 border-solid dark:bg-gray-950 border-black-125 shadow-soft-xl dark:shadow-soft-dark-xl rounded-2xl bg-clip-border">
                    <div className="p-6 pb-0 mb-0 border-b-0 border-solid border-black-125 rounded-t-2xl">
                      <h6 className="text-black text-2xl"># Recent News</h6>
                      <RSSFeed url="https://rss.app/feeds/tLqXOX3TBrBTrqRf.xml" />
                    </div>
                  </div>
              </div>
              <div className="w-full pt-px bg-gray-200 my-6" />
              {/* /End replace */}
            </div>
            <ProdzFooter />
          </main>
        </>
      </div>
    </>
  );
}

export default connector(Dashboard)